import { defineNuxtPlugin } from 'nuxt/app'

import { mediaQueryInstance } from '~/modules/app'

export default defineNuxtPlugin(({ $gaApp }) => {
  const isTruthyMediaQuery = (breakpoint) => {
    return mediaQueryInstance.isTruthyMediaQuery(
      breakpoint,
      $gaApp.stores.app.window.currentBreakpoint,
    )
  }

  return {
    provide: {
      mq: isTruthyMediaQuery,
    },
  }
})
